module.exports = __webpack_public_path__ + "static/media/18ECA43.e05913e5.jpg";